import { WorkflowAction } from './WorkflowAction';

// One thing a sweep found in the portal: a pointer to referral activity, NOT a document.
// Each item becomes its own portal_automation retrieval run (OLIO-2756), which is why a
// sweep never touches the attachments packet. Read shape is camelCase — the API stores
// snake_case keys and OliveBranch camelCases them on the response.
export interface DiscoveredItem {
  referenceOrUrl: string;
  patientName?: string | null;
  // The two demographic columns the results table renders beside the name. Both are whatever
  // text the portal rendered — nothing parses the date of birth on this path — and both are
  // absent on every sweep recorded before `facility_name` joined the captured field list, which
  // is why the table renders an em dash rather than assuming they arrive.
  patientDob?: string | null;
  // Singular on purpose. The platform's documented item shape has a plural `facilities` array;
  // a swept row captures ONE string per field, so this is a scalar under a distinct name rather
  // than a second meaning for that key.
  facilityName?: string | null;
  content?: string | null;
}

// The DiscoverPortalActivity action kind (OLIO-2757). A sweep hands off to a person or the
// browser extension, which reports what it found as `discovered_items`. Everything reads
// from THIS instance's own output, so a re-run card reflects exactly what that run found
// rather than the newest sweep's results.
export class DiscoverPortalActivityAction extends WorkflowAction {
  // A sweep that legitimately found nothing publishes an empty list — that is a real,
  // successful result, so absent and empty must read the same and neither is an error.
  get items(): DiscoveredItem[] {
    const value = this.outputFor('discovered_items');
    return Array.isArray(value) ? (value as DiscoveredItem[]) : [];
  }

  get itemCount(): number {
    return this.items.length;
  }

  get hasItems(): boolean {
    return this.itemCount > 0;
  }
}
